import type { Requests } from "../common/request.common";
import type { CustomerImportResponseTypes } from "../common/response.common";
import { download, get, post, postEmpty } from "./common";

export const customerImport = {
    record(data: typeof Requests.CustomerImport.Record.Input) {
        return post<typeof data, CustomerImportResponseTypes.Record>(
            "/data-import/customer/record",
            data,
        );
    },
    obtainRecord(id: string) {
        return (_: typeof Requests.CustomerImport.ObtainRecord.Input) => {
            return postEmpty<CustomerImportResponseTypes.ObtainRecord>(
                `/data-import/customer/obtain-record/${id}`,
            );
        };
    },
    upload(data: typeof Requests.CustomerImport.Upload.Input) {
        return (_: typeof Requests.CustomerImport.UploadRecord.Input) => {
            return post<typeof data, CustomerImportResponseTypes.UploadRecord>(
                "/data-import/customer/upload",
                data,
            );
        };
    },
    obtain(id: string) {
        return get<CustomerImportResponseTypes.Obtain>(`/data-import/customer/obtain/${id}`);
    },
    create(data: typeof Requests.CustomerImport.Create.Input) {
        return post<typeof data, CustomerImportResponseTypes.Create>(
            "/data-import/customer/create",
            data,
        );
    },
    cancel(id: string) {
        return postEmpty(`/data-import/customer/cancel/${id}`);
    },
    dev: {
        download(id: string) {
            return download(`/dev/data-import/download/${id}`);
        },
    },
};
